import { FatalErrorCommand } from "slotworks/commands/error/fatal-error-command";
import { NonFatalErrorCommand } from "slotworks/commands/error/non-fatal-error-command";
import { MessageBoxRecordSchema } from "slotworks/integration/revolver/schema/message-record-schema";
import Gameplay from "slotworks/model/gameplay/gameplay-model";
import Record from "slotworks/model/gameplay/records/record";
import { RecordBuilder } from "slotworks/server/builders/record-builder";

class MessageBoxRecordBuilder implements RecordBuilder {

    public filter(data: any): boolean {
        let alertRecord: MessageBoxRecordSchema;

        if (data && data.data) {
            alertRecord = data.data as MessageBoxRecordSchema;
        }

        return alertRecord && alertRecord.MESSAGE_BOX !== undefined;
    }

    public build(gameplay: Gameplay, data: any): Record[] {
        let alertRecord: MessageBoxRecordSchema;

        if (data && data.data) {
            alertRecord = data.data as MessageBoxRecordSchema;
        }

        const errorId = alertRecord.MESSAGE_BOX.text;
        let button = alertRecord.MESSAGE_BOX.buttons;

        if (errorId) {
            if (alertRecord.MESSAGE_BOX.fatal) {
                if (!button || button.length === 0) {
                    button = [{label: "ok", action: "refresh"}];
                }
                FatalErrorCommand(errorId, ["message"], button, alertRecord.MESSAGE_BOX.data);
            } else {
                if (!button || button.length === 0) {
                    button = [{label: "ok", action: "continue"}];
                }
                NonFatalErrorCommand(errorId, ["message"], button, alertRecord.MESSAGE_BOX.data).execute();
            }
        }
        return null;
    }
}

export default new MessageBoxRecordBuilder();



// WEBPACK FOOTER //
// ./~/slotworks/integration/revolver/builders/records/message-record-builder.ts